module.exports = __webpack_public_path__ + "media/entities/2209-2dda6f64.png";